export class PayuPayment {
  product_info: string = '';
  hash: string = '';
  payment_url: string = '';
  created_at!: Date;
}
